import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import Select from 'react-select';

import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';
import { Progress } from 'reactstrap';
import moment from 'moment';

import * as actions from '../../actions/cliente';

import IconSave from 'react-icons/lib/md/save';


import {api, request, API_URL} from '../../actions/_request';

import BarraProgreso from './BarraProgreso';

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
const rangos = [
    {label: '1 mes', value: 1},
    {label: '2 meses', value: 2},
    {label: '3 meses', value: 3},
    {label: '4 meses', value: 4},
    {label: '5 meses', value: 5},
    {label: '6 meses', value: 6},
    {label: '7 meses', value: 7},
    {label: '8 meses', value: 8},
    {label: '9 meses', value: 9},
    {label: '10 meses', value: 10},
    {label: '11 meses', value: 11},
    {label: '12 meses', value: 12},
];


class KardexProveedor extends React.Component{
  constructor(props) {

        super(props);

        this.state = {
            progreso:0,
            indice:0,
            recalcular:false,
            loading:true,
            data:[],
        };
        
        this.buscar = this.buscar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this); 
        this.handleSelectChange2 = this.handleSelectChange2.bind(this);
        this.recalcular_cliente = this.recalcular_cliente.bind(this);
        this.delayedLog = this.delayedLog.bind(this);
    }

    handleInputChange(event) {
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    handleSelectChange2(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            
                [name]: value
            
        });
    }
    componentDidMount()
    {
      this.props.progreso({indice:0,progreso:0})
      let self=this;
      api().get('/buscar_clientes_facturas')
      .then(function(response)
      {
        if(response.status === 200)
        {
           self.setState({
            
                data: response.data,
                loading:false,
            
        });
                
        }
      });   
       
    }

    buscar(evt){
      evt.preventDefault();
      let {data} = this.state;
      

      let max =data.length;
      if(data.length>0)
      this.props.recalcular_estado(true); 
      this.processArray(data);
    }

    delay() {
      return new Promise(resolve => setTimeout(resolve, 300));
    }
    async  delayedLog() {
      // notice that we can await a function
      // that returns a promise
      
      // this.recalcular_cliente();
      let {indice,recalcular,progreso} = this.props.cliente;
      let data= this.state.data;
      let max =data.length;
      if(indice<max){
      
      console.log('Cliente----->',data[indice]);
      indice++;
      progreso=(indice*100)/max;
       this.props.progreso({indice:indice,progreso:progreso});
     }else{
      console.log('Done!');
     }
      await this.delay();
    }


    async  processArray(array) {
     // array.forEach(async (item) => {
      await this.delayedLog();
      // })
      
    }



   async recalcular_cliente(){

      let {indice,recalcular,progreso} = this.props.cliente;
      let data= this.state.data;
      let max =data.length;
      console.log('Indice---->',indice);
      // console.log('max---->',max);
       let self=this;
      
      if(indice<max){
        console.log('Cliente----->',data[indice]);
        indice++;
        progreso=(indice*100)/max;
        let bandera=0;
        self.props.progreso({indice:indice,progreso:progreso});
        // while(bandera!=2){

        //   if(bandera==0){

        //     bandera=1;
        //     api().get('/buscar_clientes_facturas')
        //     .then(function(response)
        //     {
        //       if(response.status === 200)
        //       {
        //           self.props.progreso({indice:indice,progreso:progreso});
        //           bandera=2;
        //           console.log('bandera-->',bandera);
                      
        //       }
        //     });

        //   }
        //   await this.delay();
        // }
          

       
            

      }else{
        this.props.recalcular_estado(false);
      }

      
    }

    render(){
      let {data,loading} = this.state;
      let {indice,recalcular,progreso} = this.props.cliente;

  

      return(
        <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                  <div className="row">
                  <div className="col-12"> 
                    
                      <BarraProgreso lista={data}  cambio_indice={indice} cambio_progreso={progreso} termino={this.props.toggle} />
                     
                     
                     
                  </div>
                  <div className="col-12"> 
                   { false&&
                     <ReactTable
                              data      = {this.state.data}
                              className = "-striped -highlight"
                              columns   = {[

                                {Header: 'Cliente', accessor: 'cliente'},
                                {Header: 'Enviado', accessor: 'estado', filterable: false,
                                    sortable: false,
                                    maxWidth:100,minWidth:100,},
                                                     
                              
                              ]}
                               loading={loading} // Display the loading overlay when we need it
                               filterable 
                               pageSizeOptions= {[5]}  defaultPageSize={5} 
                               defaultFilterMethod={filterCaseInsensitive}
                            /> 
                   }
                  </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.cliente.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.buscar} >
                                <IconSave />&nbsp;Buscar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
      );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        cliente : state.cliente,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(KardexProveedor)


// WEBPACK FOOTER //
// ./src/views/clientes/ModalRecalculo.js